export default class ForbiddenPage {
    
}